export default class ForbiddenPage {
    
}